import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { urls } from '../../../utils/routing';

import styles from './Back.module.css';

export default class Back extends React.PureComponent {
  static propTypes = {
    children: PropTypes.node,
    glitch: PropTypes.bool,
    gtmTag: PropTypes.string,

    back: PropTypes.bool,
  }

  render() {
    if (this.props.location.state !== null) {
      if (this.props.back && this.props.location.state.lastUrl && this.props.location.state.lastUrl !== document.location.href) {
        return (
          <Link className={styles.base} to={this.props.location.state.lastUrl} state={{ lastUrl: document.location.href }}>
            <span>Назад</span>
          </Link>
        )
      } else {
        return (
            <Link className={styles.base} to={{ pathname: urls.landing, search: '', hash: '' }} state={{ lastUrl: document.location.href }}>
              <span>На главную страницу</span>
            </Link>
          )
      }
    } else {
      return (
          <Link className={styles.base} to={{ pathname: urls.landing, search: '', hash: '' }} state={{ lastUrl: document.location.href }}>
            <span>На главную страницу</span>
          </Link>
        )
    }
    /*return (
      <Link className={styles.base} to={{ pathname: urls.landing, search: '', hash: '' }} state={{ lastUrl: document.location.href }}>
        <span>На главную страницу</span>
      </Link>
    )*/
  }
}
